import "../system/constants.js";
import { toResolvedBinding as e } from "../system/matching.js";
import "../key/constants.js";
function s(n) {
  return typeof n == "object" && n !== null && "then" in n && typeof n.then == "function";
}
function r(n) {
  const t = globalThis.reportError;
  if (typeof t == "function") {
    t(n);
    return;
  }
  queueMicrotask(() => {
    throw n instanceof Error ? n : new Error(String(n));
  });
}
function u(n, t, i, o) {
  if (!o) {
    r(n);
    return;
  }
  Promise.resolve().then(() => o({ error: n, binding: e(t), event: i })).catch(r);
}
export {
  s as isPromiseLike,
  r as reportAsyncError,
  u as reportBindingError
};
